import React, {useState} from "react";
import styles from "./ConfirmationModal.module.css";
import {Button, ButtonState} from "../button/Button";
import {CloseImageButton} from "../closeImageButton/CloseImageButton";
import {CustomInputField} from "../customInputField/CustomInputField";

interface ConfirmationModalProps {
    title: string;
    subtitle: string;
    closeButtonTitle: string;
    confirmButtonTitle: string;
    onConfirm: (value?: any) => any;
    onClose: (value?: any) => any;
    confirmationText?: string;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
                                                                        title,
                                                                        subtitle,
                                                                        confirmButtonTitle,
                                                                        closeButtonTitle,
                                                                        onConfirm,
                                                                        onClose,
                                                                        confirmationText
                                                                    }) => {
    const [inputValue, setInputValue] = useState("");

    const isConfirmDisabled = confirmationText != null && inputValue !== confirmationText;

    return <div className={styles.wrapper}>
        <div className={styles.textWrapper}>
            <div className={styles.titleWrapper}>
                <span className={styles.title}>{title}</span>
                <CloseImageButton onClose={onClose}/>
            </div>
            <span className={styles.subtitle}>{subtitle}</span>
        </div>
        {confirmationText != null && (
            <div className={styles.confirmationInputWrapper}>
                <label className={styles.confirmationLabel}>
                    Type <strong>{confirmationText}</strong> to confirm
                </label>
                <CustomInputField isRequired={false} title={""} value={inputValue} setValue={setInputValue}/>
            </div>
        )}
        <div className={styles.buttonsWrapper}>
            <Button
                title={closeButtonTitle}
                state={ButtonState.SECONDARY}
                handleClick={onClose}
            />
            <Button
                title={confirmButtonTitle}
                state={isConfirmDisabled ? ButtonState.DISABLED : ButtonState.PRIMARY}
                handleClick={onConfirm}
            />
        </div>
    </div>
};
